import { useSyncExternalStore } from "react";
import type { CSSProperties } from "react";
import {
  closeCoachVeeraPanel,
  getCoachVeeraPanelSnapshot,
  openCoachVeeraPanel,
  resetCoachVeeraPanelBoundary,
  restoreCoachVeeraPanelFocus,
  subscribeToCoachVeeraPanel,
} from "@/lib/coachVeeraPanelStore";

export const COACH_VEERA_PANEL_ID = "coach-veera-panel";
export const COACH_VEERA_PANEL_WIDTH_PROPERTY = "--coach-veera-panel-width";
export const COACH_VEERA_PANEL_WIDTH = "clamp(300px,32vw,340px)";
export const COACH_VEERA_PANEL_WIDTH_STYLE = {
  [COACH_VEERA_PANEL_WIDTH_PROPERTY]: COACH_VEERA_PANEL_WIDTH,
} as CSSProperties;

export const useCoachVeeraPanel = () => {
  const panel = useSyncExternalStore(
    subscribeToCoachVeeraPanel,
    getCoachVeeraPanelSnapshot,
    getCoachVeeraPanelSnapshot,
  );

  return {
    ...panel,
    openPanel: openCoachVeeraPanel,
    closePanel: closeCoachVeeraPanel,
    resetBoundary: resetCoachVeeraPanelBoundary,
    restoreFocus: restoreCoachVeeraPanelFocus,
  };
};
